<template>
  <div>
    <div class="toolbar">
      <el-select
        v-model="workerTypeId"
        clearable
        filterable
        placeholder="工种"
        style="width:200px"
        @change="load"
      >
        <el-option v-for="d in workTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="primary" icon="el-icon-upload2" @click="openImport">导入</el-button>
    </div>
    <el-table
      :data="pageList"
      border
      v-loading="loading"
      :span-method="spanMethod"
    >
      <el-table-column prop="workerTypeName" label="工种" width="120" />
      <el-table-column prop="itemName" label="事项名称" min-width="140" />
      <el-table-column prop="unit" label="单位" width="80" />
      <el-table-column prop="price" label="单价" width="100" />
      <el-table-column prop="sortNo" label="排序" width="70" />
      <el-table-column prop="enabled" label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled===1?'success':'info'">{{ row.enabled===1?'启用':'停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑价格':'新增价格'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="工种" required>
          <dict-select-with-add
            v-if="visible"
            v-model="form.workerTypeId"
            dict-type="WORKER_TYPE"
            value-field="id"
            add-text="添加工种"
            label-placeholder="如：木工、水电工"
            placeholder="请选择工种"
          />
        </el-form-item>
        <el-form-item label="事项名称" required>
          <el-input v-model="form.itemName" placeholder="如：贴砖、乳胶漆" />
        </el-form-item>
        <el-form-item label="单位" required>
          <unit-select-with-add v-model="form.unit" />
        </el-form-item>
        <el-form-item label="单价" required>
          <el-input-number v-model="form.price" :min="0" :precision="2" :step="1" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortNo" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
      <p class="tip">工种来自「系统管理 / 字典管理」中的 WORKER_TYPE。</p>
    </el-dialog>

    <el-dialog title="导入工人价格" :visible.sync="importVisible" width="560px" @close="resetImport">
      <div class="import-steps">
        <p>1. 先下载模板，按表头填写后上传。</p>
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
        <div class="import-tips">
          <div class="import-tips-title">说明</div>
          <ol>
            <li>请从第2行开始填写，勿修改表头；带红星列为必填。</li>
            <li>工种、单位请从下拉列表选择。</li>
            <li>全部校验通过后才会导入。</li>
          </ol>
        </div>
        <p style="margin-top:12px">2. 上传填写好的 Excel（.xlsx / .xls）。</p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
          :file-list="importFileList"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <div v-if="importErrors.length" class="import-errors">
        <div class="import-errors-title">
          校验未通过：总计 {{ importTotal }} 条，成功导入 0 条。问题如下：
        </div>
        <el-table :data="importErrors" border size="mini" max-height="280">
          <el-table-column prop="message" label="问题" min-width="220" />
          <el-table-column label="行号" min-width="160">
            <template slot-scope="{ row }">{{ row.rowText || (row.rows || []).join('，') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="importVisible=false">关闭</el-button>
        <el-button type="primary" :loading="importing" :disabled="!importFile" @click="doImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listWorkerPriceItems, saveWorkerPriceItem, deleteWorkerPriceItem,
  downloadWorkerPriceItemImportTemplate, importWorkerPriceItems
} from '../../api/labor'
import { listDictOptions } from '../../api/dict'
import ListPagination from '../../components/ListPagination.vue'
import UnitSelectWithAdd from '../../components/UnitSelectWithAdd.vue'
import DictSelectWithAdd from '../../components/DictSelectWithAdd.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'WorkerPrice',
  components: { ListPagination, UnitSelectWithAdd, DictSelectWithAdd },
  mixins: [listPaging],
  data() {
    return {
      workerTypeId: null,
      workTypes: [],
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: {},
      importVisible: false,
      importing: false,
      importFile: null,
      importFileList: [],
      importErrors: [],
      importTotal: 0
    }
  },
  computed: {
    typeSpans() {
      const list = this.pageList || []
      const spans = list.map(() => 1)
      for (let i = 0; i < list.length; i++) {
        const key = typeKey(list[i])
        if (i > 0 && key === typeKey(list[i - 1])) {
          spans[i] = 0
          continue
        }
        let n = 1
        for (let j = i + 1; j < list.length && typeKey(list[j]) === key; j++) n++
        spans[i] = n
      }
      return spans
    }
  },
  created() {
    this.loadTypes()
    this.load()
  },
  methods: {
    async loadTypes() {
      try {
        const res = await listDictOptions('WORKER_TYPE')
        this.workTypes = res.data || []
      } catch (e) {
        this.workTypes = []
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listWorkerPriceItems({
          workerTypeId: this.workerTypeId || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    spanMethod({ column, rowIndex }) {
      if (column.property !== 'workerTypeName') return
      const span = this.typeSpans[rowIndex]
      if (!span) return { rowspan: 0, colspan: 0 }
      return { rowspan: span, colspan: 1 }
    },
    openEdit(row) {
      this.form = row
        ? {
          id: row.id,
          workerTypeId: row.workerTypeId,
          workerPriceId: row.workerPriceId,
          itemName: row.itemName,
          unit: row.unit || '',
          price: Number(row.price),
          sortNo: row.sortNo == null ? 0 : row.sortNo,
          enabled: row.enabled == null ? 1 : row.enabled,
          remark: row.remark || ''
        }
        : {
          id: null,
          workerTypeId: this.workerTypeId || null,
          itemName: '',
          unit: '',
          price: 0,
          sortNo: 10,
          enabled: 1,
          remark: ''
        }
      this.visible = true
    },
    async save() {
      if (!this.form.workerTypeId) return this.$message.warning('请选择工种')
      if (!this.form.itemName) return this.$message.warning('请填写事项名称')
      if (!this.form.unit) return this.$message.warning('请选择单位')
      this.saving = true
      try {
        await saveWorkerPriceItem(this.form)
        this.$message.success('已保存')
        this.visible = false
        await this.loadTypes()
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除「${row.workerTypeName || ''} · ${row.itemName}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteWorkerPriceItem(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    },
    openImport() {
      this.resetImport()
      this.importVisible = true
    },
    resetImport() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
      this.importing = false
    },
    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1)
      this.importFile = file.raw || null
      this.importErrors = []
      this.importTotal = 0
    },
    onImportFileRemove() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
    },
    async downloadTemplate() {
      try {
        const res = await downloadWorkerPriceItemImportTemplate()
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '工人价格导入模板.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('模板下载失败')
      }
    },
    async doImport() {
      if (!this.importFile) return this.$message.warning('请先选择文件')
      this.importing = true
      this.importErrors = []
      try {
        const res = await importWorkerPriceItems(this.importFile)
        const data = res.data || {}
        const total = data.total == null ? 0 : Number(data.total)
        const imported = data.imported == null ? 0 : Number(data.imported)
        this.importTotal = total
        if (data.ok) {
          this.$message.success(`导入完成：总计 ${total} 条，成功导入 ${imported} 条`)
          this.importVisible = false
          await this.loadTypes()
          this.load()
        } else {
          this.importErrors = data.errors || []
          this.$message.error(`校验未通过：总计 ${total} 条，成功导入 0 条`)
        }
      } catch (e) { /* interceptor */ }
      finally {
        this.importing = false
      }
    }
  }
}

function typeKey(row) {
  if (!row) return ''
  if (row.workerTypeId != null) return String(row.workerTypeId)
  return row.workerTypeName || ''
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; align-items:center; }
.tip { margin:8px 0 0; font-size:12px; color:#94a3b8; }
.import-steps { line-height: 1.6; }
.import-tips {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 6px;
  color: #475569;
  font-size: 13px;
}
.import-tips-title { font-weight: 600; margin-bottom: 4px; color: #334155; }
.import-tips ol { margin: 0; padding-left: 18px; }
.import-errors { margin-top: 14px; }
.import-errors-title { margin-bottom: 8px; color: #b91c1c; font-size: 13px; }
</style>
